(function () {
  // Maps "spectrum--lookingFor--experience" to a product URL.
  // Experience tiers: beginner = low dose, intermediate = medium dose, experienced = high dose.
  // "both" (THC + CBD checked) uses THC recommendations since OOO products contain both cannabinoids.
  const PRODUCT_MAP = {
    // ── THC ──────────────────────────────────────────────────────────────────

    // Anxiety
    'thc--anxiety--beginner':        '/products/out-of-office-gummies?variant=42096699179148',        // OOO THC Gummies Single (1.5mg, low)
    'thc--anxiety--intermediate':    '/products/out-of-office-mood-thc-gummies?variant=45724164522124', // Mood Gummies Balance (5mg, medium)
    'thc--anxiety--experienced':     '/products/out-of-office-mood-thc-gummies?variant=45724164522124', // Mood Gummies Balance — no high-dose anxiety THC product

    // Sleep
    'thc--sleep--beginner':          '/products/nightcap-thc-gummies',                                // Nightcap (medium, closest low-dose match)
    'thc--sleep--intermediate':      '/products/nightcap-thc-gummies',                                // Nightcap (medium)
    'thc--sleep--experienced':       '/products/out-of-office-high-dose-thc-gummies?variant=45230214086796', // High Dose Quad (10mg)

    // Pain
    'thc--pain--beginner':           '/products/out-of-office-oil-drops?variant=43426589507724',       // OOO THC Oil Drops Single (low)
    'thc--pain--intermediate':       '/products/nightcap-thc-gummies',                                // Nightcap (medium, Sleep+Pain)
    'thc--pain--experienced':        '/products/out-of-office-high-dose-thc-gummies?variant=45230214086796', // High Dose Quad (10mg)

    // Relaxation → Mood products
    'thc--relaxation--beginner':     '/products/out-of-office-gummies?variant=42096699179148',        // OOO THC Gummies Single (Mood, low)
    'thc--relaxation--intermediate': '/products/out-of-office-mood-thc-gummies?variant=45724164587660', // Mood Gummies Mellow (5mg, medium)
    'thc--relaxation--experienced':  '/products/out-of-office-gummies?variant=43281611325580',        // OOO THC Gummies Quad (10mg)

    // Focus → Mood Uplift (sativa THC+CBG, Focus/Mood/Anxiety)
    'thc--focus--beginner':          '/products/out-of-office-mood-thc-gummies?variant=45724164554892', // Mood Gummies Uplift (3mg, Focus)
    'thc--focus--intermediate':      '/products/out-of-office-mood-thc-gummies?variant=45724164554892', // Mood Gummies Uplift (3mg, Focus)
    'thc--focus--experienced':       '/products/out-of-office-mood-thc-gummies?variant=45724164554892', // Mood Gummies Uplift — best THC focus option

    // Mood → Uplift/OOO line
    'thc--mood--beginner':           '/products/out-of-office-gummies?variant=42096699179148',        // OOO THC Gummies Single (Mood, low)
    'thc--mood--intermediate':       '/products/out-of-office-mood-thc-gummies?variant=45724164554892', // Mood Gummies Uplift (Focus/Mood, medium)
    'thc--mood--experienced':        '/products/out-of-office-gummies?variant=43281611325580',        // OOO THC Gummies Quad (high)

    // ── CBD ──────────────────────────────────────────────────────────────────

    // Anxiety
    'cbd--anxiety--beginner':        '/products/cbd-gummies?variant=33727470469260',                  // CBD Gummies 10mg Raspberry (low)
    'cbd--anxiety--intermediate':    '/products/chill-cbd-capsules',                                  // Chill Capsules (Anxiety, Sleep, Mood)
    'cbd--anxiety--experienced':     '/products/chill-cbd-capsules',                                  // Chill Capsules — no high-dose CBD anxiety product

    // Sleep
    'cbd--sleep--beginner':          '/products/cbd-gummies?variant=33727470469260',                  // CBD Gummies 10mg (low)
    'cbd--sleep--intermediate':      '/products/sleepi-gummies',                                      // Sleepi Gummies (medium)
    'cbd--sleep--experienced':       '/products/sleepi-capsules',                                     // Sleepi Capsules (medium, closest to high)

    // Pain
    'cbd--pain--beginner':           '/products/cbd-gummies?variant=33727470469260',                  // CBD Gummies 10mg (low)
    'cbd--pain--intermediate':       '/products/thrive-capsules',                                     // Thrive Capsules (Pain, medium)
    'cbd--pain--experienced':        '/products/rapid-relief-cbd-cream',                              // Rapid Relief Cream (Pain, high dose topical)

    // Relaxation → Mood products
    'cbd--relaxation--beginner':     '/products/cbd-oil-drops?variant=39476187103372',                // CBD Oil Drops 500mg (low)
    'cbd--relaxation--intermediate': '/products/happi-mood-gummies',                                  // Happi Gummies (Anxiety, Mood, Focus)
    'cbd--relaxation--experienced':  '/products/happi-mood-gummies',                                  // Happi Gummies — no high-dose CBD mood product

    // Focus → Big Brain line
    'cbd--focus--beginner':          '/products/big-brain-gummies',                                   // Big Brain Gummies (low)
    'cbd--focus--intermediate':      '/products/big-brain-capsules',                                  // Big Brain Capsules (medium)
    'cbd--focus--experienced':       '/products/big-brain-capsules',                                  // Big Brain Capsules — strongest focus option

    // Mood → Happi line
    'cbd--mood--beginner':           '/products/happi-mood-gummies',                                  // Happi Gummies (low)
    'cbd--mood--intermediate':       '/products/happi-mood-gummies',                                  // Happi Gummies (medium)
    'cbd--mood--experienced':        '/products/happi-mood-gummies',                                  // Happi Gummies — no high-dose CBD mood product

    // ── BOTH (THC + CBD checked) ─────────────────────────────────────────────
    // OOO THC products already contain both cannabinoids, so we mirror THC recommendations.

    // Anxiety
    'both--anxiety--beginner':       '/products/out-of-office-gummies?variant=42096699179148',
    'both--anxiety--intermediate':   '/products/out-of-office-mood-thc-gummies?variant=45724164522124',
    'both--anxiety--experienced':    '/products/out-of-office-mood-thc-gummies?variant=45724164522124',

    // Sleep
    'both--sleep--beginner':         '/products/nightcap-thc-gummies',
    'both--sleep--intermediate':     '/products/nightcap-thc-gummies',
    'both--sleep--experienced':      '/products/out-of-office-high-dose-thc-gummies?variant=45230214086796',

    // Pain
    'both--pain--beginner':          '/products/out-of-office-oil-drops?variant=43426589507724',
    'both--pain--intermediate':      '/products/nightcap-thc-gummies',
    'both--pain--experienced':       '/products/out-of-office-high-dose-thc-gummies?variant=45230214086796',

    // Relaxation
    'both--relaxation--beginner':    '/products/out-of-office-gummies?variant=42096699179148',
    'both--relaxation--intermediate':'/products/out-of-office-mood-thc-gummies?variant=45724164587660',
    'both--relaxation--experienced': '/products/out-of-office-gummies?variant=43281611325580',

    // Focus
    'both--focus--beginner':         '/products/out-of-office-mood-thc-gummies?variant=45724164554892',
    'both--focus--intermediate':     '/products/out-of-office-mood-thc-gummies?variant=45724164554892',
    'both--focus--experienced':      '/products/out-of-office-mood-thc-gummies?variant=45724164554892',

    // Mood
    'both--mood--beginner':          '/products/out-of-office-gummies?variant=42096699179148',
    'both--mood--intermediate':      '/products/out-of-office-mood-thc-gummies?variant=45724164554892',
    'both--mood--experienced':       '/products/out-of-office-gummies?variant=43281611325580',
  };

  function initQuickQuiz(container) {
    var thcCheckbox      = container.querySelector('[data-quiz-thc]');
    var cbdCheckbox      = container.querySelector('[data-quiz-cbd]');
    var lookingForSelect = container.querySelector('[data-quiz-looking-for]');
    var experienceSelect = container.querySelector('[data-quiz-experience]');
    var button           = container.querySelector('[data-quiz-button]');

    if (!button) return;

    var defaultHref = button.getAttribute('data-quiz-default') || '#';

    function resolveSpectrum() {
      var hasTHC = thcCheckbox && thcCheckbox.checked;
      var hasCBD = cbdCheckbox && cbdCheckbox.checked;
      if (hasTHC && hasCBD) return 'both';
      if (hasTHC) return 'thc';
      if (hasCBD) return 'cbd';
      return null;
    }

    function update() {
      var spectrum   = resolveSpectrum();
      var lookingFor = lookingForSelect ? lookingForSelect.value : '';
      var experience = experienceSelect ? experienceSelect.value : '';

      if (!spectrum || !lookingFor || !experience) {
        button.setAttribute('href', defaultHref);
        return;
      }

      var key = spectrum + '--' + lookingFor + '--' + experience;
      button.setAttribute('href', PRODUCT_MAP[key] || defaultHref);
    }

    [thcCheckbox, cbdCheckbox, lookingForSelect, experienceSelect].forEach(function (el) {
      if (el) el.addEventListener('change', update);
    });

    update();
  }

  document.querySelectorAll('[data-quick-quiz]').forEach(initQuickQuiz);
})();
